import { API_URL } from '../config';
import { deleteData, getData, patchData, postData } from './http';

export const getLeads = async (page = 1, rowsPerPage, filters = {}, sortField, sortOrder) => {
  return getData(`${API_URL}/leads`, {
    params: {
      page,
      per_page: rowsPerPage,
      ...filters,
      sort_field: sortField,
      sort_order: sortOrder,
    },
  });
};

export const getLead = async (id, action) => {
  return getData(`${API_URL}/leads/${id}`, {
    params: {
      api_action: action,
    },
  });
};

export const getLeadsCount = async () => getData(`${API_URL}/leads/count`);

export const massConfirm = async (leads_id) => {
  return postData(`${API_URL}/leads/mass_confirm`, {
    leads_id,
  });
};

export const deleteLead = async (id) => {
  try {
    return await deleteData(`${API_URL}/leads/${id}`);
  } catch (e) {
    return e.response?.data;
  }
};

export const exportLeads = async () => getData(`${API_URL}/leads/export`);

export const resendEmail = async (id, action) => {
  return getData(`${API_URL}/leads/${id}/${action}`);
};

export const updateLead = async (id, lead, action) => {
  try {
    return await patchData(`${API_URL}/leads/${id}`, {
      lead,
      commit: action,
    });
  } catch (e) {
    return e.response?.data;
  }
};

export const brandDropdown = async (leadID) => {
  return getData(`${API_URL}/leads/brand_dropdown`, {
    params: {
      id: leadID,
    },
  });
};

export const assigneeUsers = async (id) => getData(`${API_URL}/leads/${id}/assignees`);

export const LeadsWithDisabledUser = async () => getData(`${API_URL}/leads/leads_with_disabled_user`);

export const SoldLeadsByBrand = async () => getData(`${API_URL}/leads/sold_leads_by_brand`);

export const assignedLeadsByUser = async (id, page = 1, rowsPerPage, filters = {}, sortField, sortOrder) => {
  return getData(`${API_URL}/leads/assigned_leads_by_user`, {
    params: {
      user_id: id,
      page,
      per_page: rowsPerPage,
      ...filters,
      sort_field: sortField,
      sort_order: sortOrder,
    },
  });
};

export const createdLeadsByUser = async (id, page = 1, rowsPerPage, filters = {}, sortField, sortOrder) => {
  return getData(`${API_URL}/leads/created_leads_by_user`, {
    params: {
      user_id: id,
      page,
      per_page: rowsPerPage,
      ...filters,
      sort_field: sortField,
      sort_order: sortOrder,
    },
  });
};

export const massReassignUsers = async (leads_id, user_id) => {
  return getData(`${API_URL}/leads/mass_reassign_users`, {
    params: {
      leads_id,
      user_id,
    },
  });
};

export const applyMassReassignUsers = async (leads_id, user_id, admin_comments) => {
  return postData(`${API_URL}/leads/apply_mass_reassign_users`, {
    leads_id,
    assignee_user_id: user_id,
    admin_comments,
  });
};

export const checkAssignee = async (id) => {
  const data = await getData(`${API_URL}/leads/${id}/is_assignee`);
  return data.is_assignee;
};

export const checkOriginator = async (id) => {
  const data = await getData(`${API_URL}/leads/${id}/is_originator`);
  return data.is_originator;
};
